export const Cross = () => {
    return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
  >
    <path
      d="M1 1L33 33"
      stroke="#262626"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M1 33L33 1"
      stroke="#262626"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
  
}